<div class="grid-x">
  <form-control-label [question]="componentData"></form-control-label>
  <div>
    <ul>
      @for (hero of heroes; track hero) {
        <li>
          {{hero}}
        </li>
      }
    </ul>
  </div>
</div>